export default __webpack_public_path__ + "static/media/K0001.aa8308a9.png";